"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _DateSelector = _interopRequireDefault(require("./DateSelector"));
var _TimeSelector = _interopRequireDefault(require("./TimeSelector"));
var _utils2 = require("./utils");
var _MonthSelector = _interopRequireDefault(require("./DateSelector/MonthSelector"));
var _utils3 = require("./DateSelector/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var getInitialSelectedDate = function getInitialSelectedDate(_ref) {
  var slots = _ref.slots,
    value = _ref.value,
    initialDate = _ref.initialDate,
    dateHasSlots = _ref.dateHasSlots;
  if (!slots.length) {
    return;
  }
  var initialSelectedDate = value ? (0, _momentTimezone.default)(value.start).startOf('day') : initialDate;
  if (initialSelectedDate && dateHasSlots(initialSelectedDate)) {
    return initialSelectedDate;
  }
  // If no initial date was specified or initial date has no slots,
  // DatePicker should render with the first date that has slots to avoid
  // displaying a "blank state" on mount and causing confusion
  var firstAvailableDate = (0, _momentTimezone.default)((0, _lodash.first)(slots).start).startOf('day');
  return firstAvailableDate;
};
var TimeslotSelector = function TimeslotSelector(props) {
  var value = props.value,
    onSelect = props.onSelect,
    slots = props.slots;
  var _useCssMedia = (0, _utils.useCssMedia)(),
    isDesktop = _useCssMedia.lg;
  var pageSize = (0, _utils2.getPageSizeFromProps)(props);
  // Dates that have available appointment slots
  var slotsByDate = (0, _lodash.groupBy)(slots, function (slot) {
    return (0, _utils.toISODate)(slot.start);
  });
  var dateHasSlots = function dateHasSlots(date) {
    return !!slotsByDate[(0, _utils.toISODate)(date)];
  };
  var _useState = (0, _react.useState)(getInitialSelectedDate(_objectSpread(_objectSpread({}, props), {}, {
      dateHasSlots: dateHasSlots
    }))),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDate = _useState2[0],
    setSelectedDate = _useState2[1];
  var selectedDateSlots = slotsByDate[(0, _utils.toISODate)(selectedDate)] || [];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPageDates = _useState4[0],
    setCurrentPageDates = _useState4[1];
  var currentDateText = selectedDate ?
  // "April 27"
  selectedDate.format('MMMM D') :
  // "April" or "April / May"
  (0, _lodash.chain)(currentPageDates).map(function (date) {
    return date.format('MMMM');
  }).uniq().value().join(' / ');
  var handleSelectTime = function handleSelectTime(time) {
    var slot = slotsByDate[(0, _utils.toISODate)(selectedDate)].find(function (slot) {
      return slot.start.format('HH:mm') === time.format('HH:mm');
    });
    onSelect(slot);
  };

  // Ensure no time component on these dates to avoid potential rounding shenanigans when diffing
  var min = (0, _momentTimezone.default)((0, _lodash.first)(slots).start).startOf('day');
  var max = (0, _momentTimezone.default)((0, _lodash.last)(slots).start).startOf('day');
  var allDates = (0, _utils3.getDatesForRange)(min, max, pageSize);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[10px] flex flex-col gap-y-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_MonthSelector.default, {
    min: min,
    max: max,
    allDates: allDates,
    selectedDate: selectedDate,
    isAvailable: dateHasSlots,
    onChange: function onChange(date) {
      setSelectedDate(date);
    }
  }), /*#__PURE__*/_react.default.createElement(_DateSelector.default, {
    allDates: allDates,
    pageSize: pageSize,
    isAvailable: dateHasSlots,
    value: selectedDate,
    onChange: setSelectedDate,
    onPageChange: function onPageChange(_ref2) {
      var dates = _ref2.dates;
      return setCurrentPageDates(dates);
    }
  })), isDesktop && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[20px] text-center tw-label-medium"
  }, currentDateText), /*#__PURE__*/_react.default.createElement(_TimeSelector.default, {
    slots: selectedDateSlots,
    onSelect: handleSelectTime,
    value: value === null || value === void 0 ? void 0 : value.start,
    markManagedAvailability: true
  }));
};
var _default = TimeslotSelector;
exports.default = _default;